export default "__VITE_ASSET__BNIeZPip__"